import { Box, Icon, Text } from '@quintoandar-tokko/jopijs';
import styles from './components.module.scss';

export default function ItemCount({
  value,
  icon = '',
  className = '',
  ...props
}) {
  const classNames = [
    styles.itemCountWrapper,
    !icon && styles.itemCountWrapperNoIcon,
    className,
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <Box className={classNames} {...props}>
      {icon && <Icon icon="icon-contactos" className={styles.itemCountIcon} />}

      <Text className={styles.itemCount}>{value}</Text>
    </Box>
  );
}
